import styles from "./WebOnlyPromptView.module.scss";
import backImg from "./backgground.png";
import topIcon from "./logo.png";
import { settings } from "imagica-corekit/dist/base/kernel/Settings";

interface Props {
  onClose: () => void;
}

export function WebOnlyPromptView(props: Props) {
  return (
    <div className={styles.container}>
      <img className={styles.bgImg} src={backImg} />
      <div className={styles.logo}>
        <img className={styles.logoImg} src={topIcon} />
      </div>
      <div className={styles.centerCard}>
        <div className={styles.content}>
          Imagica is not currently optimized for mobile. Please sign in on a desktop or laptop device to start building
          AI apps
        </div>
        <img
          className={styles.close}
          onClick={props.onClose}
          src={`${settings.S3CDN}${settings.viewAssetsPath}ACAEB5Cross.svg`}
          width="20"
          alt="icon"
        />
      </div>
    </div>
  );
}
